import React from "react";
import {Link} from "react-router-dom";

class PurchaseESimBanner extends React.Component {
  render() {
    return (
      <section className="header_section header_section_buy_esim">
        {/* <div className="bg-overlay" / >*/}
        <div className="container">
          <div className="row">

            {/*<div className="col-lg-8">*/}
            <div className="col-lg-10">
              <div className="desktop-header">
                {/*<h1 className="sub no-margin bold600 mb-3">MIGHTY eSIM</h1>*/}
                <div className="col-md-12" style={{ clear: "both", height: "20px" }} />
                  {/*<div className="row col-md-12">
                    <strong>What’s an eSIM Cell Phone Plan?</strong><br/>
                      An eSIM cell phone plan is a digital SIM card that is embedded within a mobile device, enabling users to access mobile networks without needing a physical SIM card. It provides phone calls, text messages, and cellular data (internet access) like a regular mobile plan, but with the added convenience of being built into the device.
                  </div>*/}
                  {/*<div className="row" style={{paddingTop: "350px"}}>
                    <ul>
                      <li><strong>Your device must be eSIM-compatible. Check: Android iPhone</strong></li><br/>
                      <li><strong>Check the confirmation email we sent you and follow the instructions.</strong></li><br/>
                      <li><strong>Your phone will automatically connect to the internet network upon arrival.</strong></li>
                    </ul>
                  </div>*/}
              </div>
            </div>

            <div className="col-lg-4"></div>

            {/*
            <div className="mobile-header">
              <h2 className="SansSerif bold600 m-title-positon">
                <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                MightyWifi Cloud
              </h2>
            </div>
            */}

          </div>
        </div>
        <div id="BuySection"></div>
      </section>
    );
  }
}

export default PurchaseESimBanner;



// WEBPACK FOOTER //
// ./src/reusable/PurchaseESimBanner.js